import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { OzonSettings } from 'src/app/models/integrations/ozon/ozon.model';
import { NotificationService, ValidatorsService } from 'src/app/services';
import { ApiOzonSettingsService } from 'src/app/services/integrations/ozon/api-ozon-settings.service';
import { OzonSettingsValidator } from '../ozon-setting.validator';

@Component({
  selector: 'app-ozon-settings',
  templateUrl: './ozon-settings.component.html',
  styleUrls: ['./ozon-settings.component.css']
})
export class OzonSettingsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  settings: OzonSettings;
  loading: boolean;

  form: UntypedFormGroup = this.fb.group({
    id:         [null],
    client_id:  [null],
    apikey:     [null, this.validator.apikey],
  });


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private apiOzonSettings: ApiOzonSettingsService,
    private notification: NotificationService,
    private validator: OzonSettingsValidator,
    private validatorService: ValidatorsService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
    
    this.onEdit();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  initForm(): void {

    if(this.settings != null){

      this.form.setValue({
        id:         this.settings.id,
        client_id:  this.settings.client_id,
        apikey:     this.settings.apikey
      });
    }
  }


  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();
    
    this.subscriptions.add(
      this.apiOzonSettings.uploadInfo().subscribe((response: any) => { console.log('[RESPONSE] getCredentialData: ', response);

        if(response != null){

          this.settings = response.result;

          this.initForm();
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete(); 
      })
    );
  }


  /**
   * 
   */
  onSave(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(
      this.apiOzonSettings.uploadSave(this.form.value).subscribe((response: any) => { console.log('[RESPONSE] saveCredentialData: ', response);

        if(response != null){

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
        this.loading = false;
      },
      error => { 
        this.progressRef.complete(); 
        this.loading = false;
      })
    );
  }


  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.form.get(field));
  }


}
